import getLocalString from "constants/Localization";
import {
  useUpdateJobChecklistItemsMutation,
  useUpdateJobPhaseChecklistItemsMutation,
} from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateJobPhaseChecklistItems() {
  const [mutation, { loading, data, error }] = useUpdateJobChecklistItemsMutation({
    refetchQueries: ["getJob", "customGetJob"],
  });

  const [updateJobChecklistItems, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateJobChecklistItems",
    },
    {
      successMessage: getLocalString("jobs.update-checklist-items-success"),
      failureMessage: getLocalString("jobs.update-checklist-items-failure"),
    }
  );

  return [updateJobChecklistItems, context] as const;
}
